import BrokerRec from './BrokerRec';
import {authRoles} from 'auth/auth';
import LoadUserData from '../../LoadUserData';

export const BrokerRecConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth    : authRoles.admin,
    routes  : [
        {
            path     : '/broker_rec',
            component: LoadUserData(BrokerRec)
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/broker_rec/BrokerRecConfig.js